var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlertaAnulada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFB642",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.146 0 0 3.146 0 7s3.146 7 7 7 7-3.146 7-7-3.146-7-7-7zm3.225 7.93H3.637V6.442h6.588v1.49z",
    transform: "translate(-337 -343) translate(22 265) translate(315 78)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlertaAnulada);
export default __webpack_public_path__ + "static/media/system-alerta-anulada.8fca0d88.svg";
export { ForwardRef as ReactComponent };